/**
 * Validation Utilities
 */

import { CartItem } from '../types/cart.types';
import { DOMUtils } from './dom.utils';

export class ValidationUtils {
  /**
   * Validate email format
   */
  static isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * Validate product quantity
   */
  static isValidQuantity(quantity: number, maxQuantity?: number): boolean {
    if (quantity < 1) return false;
    if (maxQuantity && quantity > maxQuantity) return false;
    return true;
  }

  /**
   * Validate cart item
   */
  static isValidCartItem(item: Partial<CartItem>): item is CartItem {
    return !!(
      item.id &&
      item.productID &&
      item.name &&
      typeof item.price === 'number' &&
      item.price >= 0 &&
      typeof item.quantity === 'number' &&
      item.quantity > 0 &&
      item.category
    );
  }

  /**
   * Validate currency code
   */
  static isValidCurrency(currency: string): boolean {
    const validCurrencies = ['USD', 'EUR', 'GBP', 'JPY', 'CNY', 'INR', 'CAD', 'AUD'];
    return validCurrencies.includes(currency.toUpperCase());
  }

  /**
   * Validate locale code
   */
  static isValidLocale(locale: string): boolean {
    const localeRegex = /^[a-z]{2}-[A-Z]{2}$/;
    return localeRegex.test(locale);
  }

  /**
   * Sanitize HTML string
   */
  static sanitizeHTML(html: string): string {
    const temp = DOMUtils.createElement('div');
    temp.textContent = html;
    return temp.innerHTML;
  }

  /**
   * Check if string is empty or whitespace
   */
  static isEmpty(value: string | null | undefined): boolean {
    return !value || value.trim().length === 0;
  }
}

